// ============================================================
// OAMATECH ERP PRO - Cierre automático de sesión por inactividad
// ============================================================
import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const INACTIVIDAD_MS = 8 * 60 * 60 * 1000; // 8 horas por defecto
const AVISO_MS = 5 * 60 * 1000; // Aviso 5 minutos antes

export function useAutoLogout(tiempoMs = INACTIVIDAD_MS) {
  const { logout, usuario } = useAuth();
  const navigate = useNavigate();
  const timerLogout = useRef(null);
  const timerAviso  = useRef(null);

  const resetTimer = useCallback(() => {
    clearTimeout(timerLogout.current);
    clearTimeout(timerAviso.current);

    if (!usuario) return;

    // Aviso antes de cerrar
    timerAviso.current = setTimeout(() => {
      toast('⚠️ La sesión cerrará en 5 minutos por inactividad', { duration: 10000, icon: '⏰' });
    }, tiempoMs - AVISO_MS);

    // Cierre automático
    timerLogout.current = setTimeout(() => {
      toast.error('Sesión cerrada por inactividad');
      logout();
      navigate('/login');
    }, tiempoMs);
  }, [logout, navigate, usuario, tiempoMs]);

  useEffect(() => {
    if (!usuario) return;

    const eventos = ['mousedown','mousemove','keydown','scroll','touchstart','click'];
    eventos.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      clearTimeout(timerLogout.current);
      clearTimeout(timerAviso.current);
      eventos.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [resetTimer, usuario]);
}
